import { FormattedMessage } from 'react-intl'
import makeStyles from '@mui/styles/makeStyles'
import { ChallengeComputedState } from 'utils/challenges'
import { UserChallenge } from 'api/types'

const useStyles = makeStyles(() => ({
  statusBox: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2px 10px',
    minHeight: '20px',
    lineHeight: 1,
    fontSize: '14px',
    fontWeight: '400',
    borderRadius: '12px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    color: '#FFF',
  },
  live: {
    background: '#098F50',
  },
  upcoming: {
    background: '#f0ba00',
  },
  draft: {
    background: '#f00000',
  },
}))

interface Props {
  challengeComputedState: UserChallenge['computedState']
  className?: string
}

const UserChallengeStatusBadge = ({ challengeComputedState, className }: Props): JSX.Element => {
  const classes = useStyles()
  if (challengeComputedState === ChallengeComputedState.LIVE) {
    return (
      <div className={`${className} ${classes.statusBox} ${classes.live}`}>
        <FormattedMessage id="strings.live" />
      </div>
    )
  }
  // For upcoming challenges, we currently use the VISIBLE computed state.
  // The original specification was written for sponsored challenges, so VISIBLE
  // here indicates that the user has been invited or has joined, but the challenge has not started yet.
  if (challengeComputedState === ChallengeComputedState.VISIBLE) {
    return (
      <div className={`${className} ${classes.statusBox} ${classes.upcoming}`}>
        <FormattedMessage id="strings.upcoming" />
      </div>
    )
  }
  if (challengeComputedState === ChallengeComputedState.DRAFT) {
    return (
      <div className={`${className} ${classes.statusBox} ${classes.draft}`}>
        <FormattedMessage id="strings.draft" />
      </div>
    )
  }
  return <></>
}

export default UserChallengeStatusBadge
